import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "title", "children"];
import React, { useEffect, useMemo } from 'react';
import { useTabsContext } from './context';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Tab = function Tab(_ref) {
  var id = _ref.id,
      title = _ref.title,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useTabsContext = useTabsContext(),
      current = _useTabsContext.current,
      setCurrent = _useTabsContext.setCurrent,
      activeId = _useTabsContext.activeId;

  var onKey = function onKey(t, ev) {
    return ev.keyCode === 13 && setCurrent(t);
  };

  var tab = useMemo(function () {
    return {
      id: id,
      title: title,
      children: children
    };
  }, [children, id, title]);
  var isCurrent = !current && tab.id === activeId;
  useEffect(function () {
    if (isCurrent) setCurrent(tab);
  }, [isCurrent, setCurrent, tab]);
  return ___EmotionJSX("div", _extends({
    role: "button",
    className: current && id === current.id ? 'active' : '',
    key: id,
    onClick: setCurrent.bind(null, tab),
    onKeyDown: onKey.bind(null, tab),
    tabIndex: -1
  }, rest), title);
};

Tab.displayName = 'Tab';
export { Tab };

if (typeof Tab !== 'undefined' && Tab && Tab === Object(Tab) && Object.isExtensible(Tab) && !Object.prototype.hasOwnProperty.call(Tab, '__filemeta')) {
  Object.defineProperty(Tab, '__filemeta', {
    configurable: true,
    value: {
      name: "Tab",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Tabs/tab.js"
    }
  });
}